import { useMemo } from 'react'

/**
 * Hook to access the org_hide_pricing setting for the current project.
 * Returns a function that checks if pricing should be hidden for a specific organization.
 * Works both inside and outside of Form components by using global project form.
 */
export const useOrgHidePricing = (): ((orgId: string | number) => boolean) => {
  return useMemo(() => {
    return (orgId: string | number) => {
      // Try to get org_hide_pricing from global project form first
      try {
        if (window.projectForm) {
          const projectData = window.projectForm.getState().values
          const orgHidePricing = projectData?.org_hide_pricing

          // Check if org_hide_pricing exists and is a valid non-empty object
          if (
            orgHidePricing &&
            typeof orgHidePricing === 'object' &&
            !Array.isArray(orgHidePricing) &&
            Object.keys(orgHidePricing).length > 0
          ) {
            // Convert orgId to string for consistent lookup
            const orgIdStr = String(orgId)
            // Only return true if the org is explicitly found and set to true
            return orgHidePricing[orgIdStr] === true
          }
        }
      } catch (error) {
        console.warn('Could not access project data for org_hide_pricing setting:', error)
      }

      // Default to false if we can't access project data or org_hide_pricing
      return false
    }
  }, [])
}
